import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import ReactDatePicker from 'react-datepicker';
import { useIntl } from 'react-intl';

type Props = {
  label?: string | React.ReactElement;
  disabled: boolean;
  date: Date | null;
  onChangeDate: (date: Date | null) => void;
  labelWidth?: string;
  labelPadding?: string | number;
  variant?: 'horizontal' | 'vertical';
};

export const CustomDatePicker = ({
  label,
  disabled,
  date,
  onChangeDate,
  labelWidth = '50%',
  labelPadding = 3,
  variant = 'horizontal',
}: Props) => {
  const DatePickerLayout = variant === 'horizontal' ? HStack : VStack;
  const intl = useIntl();

  return (
    <DatePickerLayout w="full" m={0}>
      {label && (
        <Box w={labelWidth}>
          <Text px={labelPadding} color={disabled ? 'gray.200' : 'black'}>
            {label}
          </Text>
        </Box>
      )}
      <Box
        p={0.5}
        pl={2}
        border="1px solid"
        borderColor={disabled ? 'gray.200' : 'gray.400'}
        borderRadius="lg"
      >
        <ReactDatePicker
          disabled={disabled}
          selected={date}
          placeholderText={intl.formatMessage({ id: 'realm_user_date_placeholder' })}
          onChange={(date) => onChangeDate(date || null)}
          className="custom-datepicker"
        />
      </Box>
    </DatePickerLayout>
  );
};
